// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-E":"E_sp-175w-E__SHTcZ"};